import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdDragIndicator } from 'react-icons/md';
import { IconEye, IconEdit, IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface ClientData {
  id: number;
  name: string;
  tasks: any[];
  assign_drivers: any[];
}

interface ClientListTableProps {
  clientData: ClientData[];
  onDragStart: (index: number) => void;
  onDragEnter: (index: number) => void;
  onDragEnd: () => void;
  onDeleteClick: (client: ClientData) => void;
}

const ClientListTable: React.FC<ClientListTableProps> = ({
  clientData,
  onDragStart,
  onDragEnter,
  onDragEnd,
  onDeleteClick,
}) => {
  const { t } = useTranslation('client');
  const navigate = useNavigate();

  const handleEditClick = (id: number) => {
    navigate(`/client/${id}/edit`);
  };

  const handleViewClick = (id: number) => {
    navigate(`/client/${id}/view`);
  };

  return (
    <section className="flex flex-col w-full">
      <div className="flex flex-row bg-gray-100 rounded-md p-2">
        <h6 className="flex-1 pl-4">{t('table.client_id')}</h6>
        <h6 className="flex-1">{t('table.client_name')}</h6>
        <h6 className="flex-1 text-center">{t('table.task_counts')}</h6>
        <h6 className="flex-1 text-center">{t('table.assignees')}</h6>
        <h6 className="flex-1 text-center">{t('table.action')}</h6>
      </div>
      {clientData.map((item, index) => (
        <div
          key={item.id}
          className="flex flex-row border-b p-2"
          draggable
          onDragStart={() => onDragStart(index)}
          onDragEnter={() => onDragEnter(index)}
          onDragEnd={onDragEnd}
        >
          <div className="flex flex-1 flex-row items-center text-gray-400 pl-4">
            <MdDragIndicator className="cursor-move mr-2" size={20} />
            <p className="flex-1">{item.id}</p>
          </div>
          <p className="flex-1">{item.name}</p>
          <p className="flex-1 text-center">
            {item.tasks.length} {t('table.task')}
          </p>
          <p className="flex-1 text-center">
            {item.assign_drivers.length} {t('table.driver')}
          </p>
          <div className="flex flex-1 justify-center items-center space-x-3 text-neutral/100 cursor-pointer">
            <IconEye
              stroke={1.5}
              size={20}
              onClick={() => handleViewClick(item.id)}
            />
            <IconEdit
              stroke={1.5}
              size={20}
              onClick={() => handleEditClick(item.id)}
            />
            <IconTrash
              stroke={1.5}
              size={20}
              onClick={() => onDeleteClick(item)}
            />
          </div>
        </div>
      ))}
    </section>
  );
};

export default ClientListTable;
